import styled from 'styled-components';
import { fontBody, fontTitle } from 'Styles/fonts';
import { NotificationBody } from '../../../Notification/Notification';

export const LoginLink = styled.button`
  ${fontTitle(14)};
  color: var(--primary);
  text-decoration: underline;
  background: none;
  border: 0;
  cursor: pointer;
`;

export const FormWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px 8px;

  *:nth-child(1),
  *:nth-child(n + 4) {
    grid-column: span 2;
  }
`;

export const LoginText = styled.p`
  ${fontBody(14)};
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid var(--ring);
  text-align: center;
`;

export const OrText = styled.p`
  ${fontBody(14)};
  margin: 8px 0;
  text-align: center;
`;

export const DisclaimerText = styled.p`
  ${fontBody(14)};
  text-align: center;
  margin-top: 16px;

  & > a {
    color: var(--foreground);
    text-decoration: underline;
  }
`;

export const Text = styled.p`
  ${fontBody(16)};
  text-align: center;
  margin: 0 0 16px;
`;

export const Emphasis = styled.b`
  font-weight: 800;
`;

export const SignUpForm = styled.div``;

export const NotificationError = styled(NotificationBody)`
  display: block;
  width: 100%;
  border-radius: 4px;
`;
